import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom'
import Container from '../../utils/Container'
import Button from '../../elements/buttons/Button'
import logo from '../../../medias/logo/logo-rita-3.svg'
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";
import LoadImage from '../../elements/images/LoadImage'


function NavBar({ classe }) {

    //state
    const [showMobileMenu, setShowMobileMenu] = useState(false)
    const [currentPage, setCurrentPage] = useState("accueil")
    
    return (
        <nav className={`${classe} navbar pt-12 md:mt-0  lg:pt-12`}>
            <Container classe="flex justify-between items-center font-nunito  md:px-5">
            <div>
                <Link to="/">
                    <img 
                        src={logo} 
                        alt="spécialiste en traduction des langues: Rita nsangou"
                        title="Rita nsangou est spéciqlisé dans la traduction des langues"
                        className="w-32 md:w-40"
                    />
                </Link>
            </div>

            <div className="hidden md:block">
                <ul className="flex space-x-5 text-secondary text-sm uppercase">
                    <NavLink to="/" className="animate  px-3 py-1.5 text-secondary hover:bg-primary hover:text-white hover:rounded-sm">
                        Accueil
                    </NavLink>
                    <NavLink to="/about" activeClassName="selected" className="animate px-3 py-1.5 text-secondary hover:bg-primary hover:rounded-sm hover:text-white">
                        À propos
                    </NavLink>
                    <NavLink to="/faqs" activeClassName="selected" className="animate px-3 py-1.5 text-secondary hover:bg-primary hover:rounded-sm hover:text-white">
                        FAQS
                    </NavLink>
                    <NavLink to="/contact" activeClassName="selected" className="animate px-3 py-1.5 text-secondary hover:bg-primary hover:rounded-sm hover:text-white">
                        Contact
                    </NavLink>
                    {/*<NavLink to="/admin" activeClassName="selected" className="animate px-3 py-1.5 text-secondary hover:bg-primary hover:rounded-sm hover:text-white">
                        admin
                    </NavLink>*/}
                </ul>
            </div>

            <a 
                href="https://www.linkedin.com/in/ritansangou/"
                target="_blanck"
                className="animate hover:-translate-y-1 rounded-full linkedin shadow-md bg-primary hover:bg-primary-hover text-white h-5 text-xl font-bold hidden md:flex justify-center items-center p-5 tracking-wide"
              >
                in
            </a>

            {
                !showMobileMenu && (
                    <GiHamburgerMenu
                        onClick={ ()=>setShowMobileMenu(true) }
                        color="#ffffff"
                        className="md:hidden w-10 bg-primary shadow-md rounded-full p-2 h-10 cursor-pointer"
                     />
                )
            }
            {
               showMobileMenu && <MobileNavigation showMobileMenu={showMobileMenu} onSetShowMobileMenu={() => setShowMobileMenu(false)}  />
            }
            </Container>
        </nav>
    );
}

const MobileNavigation = ({ showMobileMenu, onSetShowMobileMenu }) => {

    return(
        <section className="fixed z-40 left-0 top-0 w-full h-screen bg-white">
            <div className="flex justify-end m-5">
                <IoMdClose
                    color="#ffffff"
                    className="md:hidden  w-10 bg-primary shadow-md rounded-full p-2 h-10 cursor-pointer"
                    onClick={onSetShowMobileMenu}
                 />
            </div>
            <div className="flex justify-center bg-gray-700 w-full p-10">
                <Button
                    link="/contact"
                    classe=""
                >
                    me contacter
                </Button>
            </div>
             <div className="mt-16 text-center">
                <ul className="h-full flex flex-col space-y-16">
                    <NavLink 
                        to="/" 
                        className="text-xl text-secondary hover:text-secondary-hover">
                        Accueil
                    </NavLink>
                    <NavLink 
                        to="/about" 
                        activeClassName="selected"
                        className="text-xl text-secondary hover:text-secondary-hover">
                        A propos
                    </NavLink>
                    <NavLink 
                        to="/faqs"
                        activeClassName="selected" 
                        className="text-xl text-secondary hover:text-secondary-hover">
                        FAQS
                    </NavLink>
                    <NavLink 
                        to="/contact"
                        activeClassName="selected" 
                        className="text-xl text-secondary hover:text-secondary-hover">
                        Contact
                    </NavLink>
                </ul>
            </div>
        </section>
    )
}

export default NavBar;